// Aether Markets — Institutional digital-asset desk (Graphite #14110F · Amber #F59E0B · Coral)
export const META = { brand: 'Aether Markets', tag: 'Institutional digital-asset desk · MTF licence #482-INST', est: '2018' };
export const ROUTES = [
  { id: 'home', label: 'Desk' },
  { id: 'tape', label: 'Live tape' },
  { id: 'thesis', label: 'House thesis' },
  { id: 'access', label: 'Request access' },
];

export const TAPE = [
  { sym: 'BTC/USD', last: '94,418.20', ch: '+0.42%', vol: '$2.41B', state: 'up' },
  { sym: 'ETH/USD', last: '3,241.85', ch: '−0.18%', vol: '$1.18B', state: 'down' },
  { sym: 'SOL/USD', last: '218.04', ch: '+2.14%', vol: '$612M', state: 'up' },
  { sym: 'AVAX/USD', last: '38.92', ch: '+1.07%', vol: '$184M', state: 'up' },
  { sym: 'LINK/USD', last: '21.66', ch: '−0.84%', vol: '$92M', state: 'down' },
  { sym: 'ATOM/USD', last: '8.41', ch: '+0.62%', vol: '$48M', state: 'up' },
  { sym: 'XRP/USD', last: '2.314', ch: '−1.41%', vol: '$1.04B', state: 'down' },
  { sym: 'DOT/USD', last: '7.18', ch: '+0.91%', vol: '$32M', state: 'up' },
];

export const STATS = [
  { k: 'Aggregate AUM', v: '$4.8B', n: 'Custody & advisory' },
  { k: 'Active LPs', v: '47', n: 'Family offices · Funds · DAO treasuries' },
  { k: 'Assets traded', v: '186', n: 'BTC · ETH · L1s · staking pairs' },
  { k: 'Median trade', v: '$1.4M', n: 'Block · OTC · scheduled' },
];

export const PILLARS = [
  { code: '01', t: 'Block desk', d: 'OTC settlement of $250k+ trades. Two-sided quotes from 9 PB liquidity providers, RFQ in under 800ms median, FIX 4.4 connectivity for funds.' },
  { code: '02', t: 'Cold custody', d: 'Multi-party computation, 14-of-21 threshold quorum, fully insured to $400M by Marsh. SOC2 Type II audited annually by Big 4.' },
  { code: '03', t: 'Yield desk', d: 'Institutional staking, basis trades, and curated DeFi exposure. Each strategy is risk-rated and netted at the master account.' },
];

export const NOTES = [
  { iss: '21', date: 'Feb 5, 2026', cat: 'Macro', t: 'Why we are leaning into the L1 rotation in Q1.', mins: '8' },
  { iss: '20', date: 'Jan 22, 2026', cat: 'Custody', t: 'A note on the new MiCA framework and our custody readiness.', mins: '12' },
  { iss: '19', date: 'Jan 8, 2026', cat: 'Macro', t: 'On the structural bid for spot BTC ETF flows.', mins: '6' },
];
